import React, { Fragment, useContext, useState } from "react";
import { useSelector } from "react-redux";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

const NavHader = () => {
  const app = useSelector((state) => state.auth.appSetting);
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);
  return (
    <div className="nav-header">
      <Link to="/users" className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            {app && app.icon && <img src={`/logo/${app.icon}`} />}
            <span className="brand-title">
              {app?.name || "Assestment Web Admin"}
            </span>
          </Fragment>
        ) : (
          <Fragment>
            {app && app.icon && <img src={`/logo/${app.icon}`} />}
            <span className="brand-title">
              {app?.name || "Assestment Web Admin"}
            </span>
          </Fragment>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
